import React from 'react';
import {
  MenuItem, OutlinedInput, Select, SelectChangeEvent,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import LABELS from 'app/shared/constants/Literals';
import { ASAP_TIME } from 'app/shared/constants/constants';

const StyledSelect = styled(Select)(() => ({
  width: 160,
  height: 45,
  borderRadius: 45,
  borderStyle: 'solid',
  borderWidth: 2,
  '&:focus': {
    borderRadius: 45,
  },
}));

const StyledOutlinedInput = styled(OutlinedInput)(() => ({
  borderRadius: 45,
  border: 'none',
  boxShadow: '6px 6px 6px #cbced1, -6px -6px 6px #fff',
  height: 40,
  '& .MuiSelect-select': {
    padding: '10px 14px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:focus': {
      backgroundColor: 'transparent',
    },
  },
  '& legend': {
    display: 'none',
  },
  '& fieldset': {
    top: 0,
    display: 'none',
  },
}));

const StyledMenuItem = styled(MenuItem)(() => ({
  border: '2px solid',
  boxShadow: '6px 6px 6px #cbced1, -6px -6px 6px #fff',
  borderRadius: 45,
  marginTop: '20px !important',
  textAlign: 'center',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: 150,
  height: 45,
  '&:first-of-type.Mui-disabled': {
    display: 'none',
  },
}));

const menuPaperStyles = {
  borderRadius: '.375rem',
  px: 1,
  border: '1px solid rgba(0,0,0,.175)',
  '& .MuiMenu-list': {
    maxHeight: 400,
    padding: '8px 0px',
  },
};

interface StyledPickupSelectProps {
  options: string [];
  onChange: (event: SelectChangeEvent<unknown>, child?: React.ReactNode) => void;
  name?: string;
  value?: string;
  className?: string;
  id: string;
  labelFormater?: (text: string) => string;
}

const StyledPickupSelect: React.FC<StyledPickupSelectProps> = ({
  options,
  onChange,
  name,
  value,
  className = "btn-select-date-time",
  id,
  labelFormater,
}) => {
  let emptyOptionText = '';
    switch (name) {
      case 'pickupType':
        emptyOptionText = LABELS.FUTURE_ORDERS.emptyPickupType;
        break;
      case 'pickupDate':
        emptyOptionText = LABELS.FUTURE_ORDERS.emptyPickupDate;
        break;
      case 'pickupTime':
        emptyOptionText = LABELS.FUTURE_ORDERS.emptyPickupTime;
        break;
      default:
        break;
    }
    const renderValue = React.useCallback((selectedValue: unknown): React.ReactNode => {
      if (selectedValue === ASAP_TIME) {
        return (
          <span>
            <span>{selectedValue.split(' ')[0]}</span>
            &nbsp;
            <span className="font-sub asap-text">
              {selectedValue.split(' ').slice(1).join(' ')}
            </span>
          </span>
        );
      }
      if (selectedValue === '') {
        return emptyOptionText;
      }
      return labelFormater
        ? labelFormater(selectedValue as string)
        : selectedValue as React.ReactNode;
    }, [emptyOptionText, labelFormater]);
  return (
    <StyledSelect
      className={className}
      data-testid={id}
      name={name}
      value={value}
      displayEmpty
      onChange={onChange}
      renderValue={renderValue}
      input={<StyledOutlinedInput />}
      inputProps={{
        'aria-label': emptyOptionText,
      }}
      MenuProps={{
        PaperProps: {
          sx: menuPaperStyles,
        },
      }}
    >
      <StyledMenuItem value="" disabled className="btn-select-date-time-opt">
        {emptyOptionText}
      </StyledMenuItem>
      {options?.map((option) => (
          <StyledMenuItem value={option} key={option} className="btn-select-date-time-opt">
              {labelFormater ? labelFormater(option) : option}
          </StyledMenuItem>
      ))}
    </StyledSelect>
  );
};

export default StyledPickupSelect;
